import { render, staticRenderFns } from "./Fees.vue?vue&type=template&id=af16815c&scoped=true"
import script from "./Fees.vue?vue&type=script&lang=js"
export * from "./Fees.vue?vue&type=script&lang=js"
import style0 from "./Fees.vue?vue&type=style&index=0&id=af16815c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-load_1d815c3a82e414dc02ba46af5dbd33b7/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af16815c",
  null
  
)

export default component.exports